module.exports = "/assets/c3cc04d5b790e9154306a517264fd936.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/FL.png
// module id = 1373
// module chunks = 0